import styled from "@emotion/styled";

export const Line = styled.div`
  height: 1px;
  border: 1px solid #ffffff;
  margin-bottom: 22px;
`;
